<template>

    <div class="quote-step quote-step-verification">

        <div class="verification-header">
            <div class="icon" v-html="$icon('password')"></div>

            <h1 class="title">{{ 'quote.verification.title' | __ }}</h1>
            <p class="subtitle">{{ 'quote.verification.sent_to' | __ }} - {{ form.phoneNumber }}</p>
        </div>

        <form class="form" @submit.prevent="send">

            <div class="form-error-message" v-if="errors.get('form')">
                {{ errors.get('form') }}
            </div>

            <div class="form-row">
                <app-input label="quote.verification.type_hear"
                           autofocus
                           :message="errors.get('code')"
                           v-model="form.code">
                </app-input>
            </div>

            <div class="message">
                {{ 'quote.verification.didnt_get' | __ }}

                <a class="button" @click.prevent="sendCode">
                    {{ this.sending ? 'quote.verification.sending' : 'quote.verification.send_again' | __ }}
                </a>
            </div>

            <div class="submit-row">
                <app-button icon="arrow"
                            :disabled="form.code.length < 4"
                            :loading="loading">
                    {{ 'quote.verification.start' | __ }}
                </app-button>
            </div>
        </form>

    </div>

</template>

<script>
    import QuoteStep from "../../mixins/QuoteStep";

    export default {

        mixins: [QuoteStep],

        data() {
            return {
                sending: false
            }
        },

        methods: {

            async sendCode() {
                this.sending = true;

                let response = await this.$api.post('verification/guest/send', this.form);
                this.errors = response.errors();

                this.sending = false;
            },

            async send() {
                this.loading = true;

                let response = await this.$api.post('verification/guest/code', this.form);
                this.errors = response.errors();

                if(! response.hasErrors()) {
                    if (this.lead.active) {
                        await this.$api.post("quote/send-lead", this.form);

                        this.loading = false;
                        window.location.href = this.lead.url;

                        return;
                    }

                    this.$emit('verified', response.data().next);
                }

                this.loading = false;
            }

        }

    }

</script>

<style lang="scss" scoped>

    .quote-step-verification {

        .verification-header {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            margin-bottom: 80px;

            .title {
                font-size: 63px;
                font-weight: bold;
                line-height: 1.3;
                color: $black;
                margin: 30px 0 15px;

                @media all and (max-width: $mobile) {
                    margin: 25px 0 15px;
                    font-size: 25px;
                }

            }

            .subtitle {
                font-size: 25px;
                font-weight: $font-light;
                line-height: 1.32;
                color: $black;

                @media all and (max-width: $mobile) {
                    font-size: 18px;
                }
            }
        }

    }

    .form-row {
        max-width: 300px;
    }

    .message {
        margin-top: 45px;
        margin-bottom: 80px;
        font-size: 20px;
        font-weight: bold;
        line-height: 1.3;
        color: $black;

        a {
            color: $primary-blue;
            margin-right: 20px;
            cursor: pointer;
        }
    }

    .form {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        text-align: center;
    }

</style>
